import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="policy-container">
      <h1>Terms and Conditions</h1>
      <p><strong>Effective Date:</strong> 12 June 2025</p>
      <p>By using our website and purchasing any of our educational products or services, you agree to the following terms and conditions.</p>
      <h3>1. Course Access</h3>
      <p>Upon successful enrollment, users are granted access to the purchased course(s) for a period of 1 year.</p>
      <h3>2. Account Usage</h3>
      <p>Users are responsible for maintaining the confidentiality of their account credentials.</p>
      <h3>3. Intellectual Property</h3>
      <p>All content provided on the platform, including videos, PDFs, practice problems, and code, is the intellectual property of SmileGuide.</p>
      <h3>4. Prohibited Conduct</h3>
      <ul>
        <li>Share login credentials with others.</li>
        <li>Reproduce or redistribute course content.</li>
        <li>Engage in any form of piracy or unauthorized recording or downloading of course materials.</li>
      </ul>
      <h3>5. Changes to Terms</h3>
      <p>We reserve the right to update these terms at any time. Continued use of the website after changes constitutes acceptance of the new terms.</p>
    </div>
  );
};

export default TermsAndConditions;
